import { SettingsIcon } from '@assets/icons';
import { LogoBlue } from '@assets/images';
import { AppTooltip } from '@components/commons';
import { IconButton, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import { Routes } from '@utils/constants';
import { FC } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import './AuthLayout.scss';
import routes from '@utils/constants/routes';

interface AuthLayoutProps {}

const AuthLayout: FC<AuthLayoutProps> = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="AuthLayout">
      <div className="Header">
        <img src={LogoBlue} />
        {location.pathname === routes.LOGIN && (
          <AppTooltip title="login.setting_timeline_app" placement="bottom">
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={() => navigate(Routes.SETTING)}
              color="inherit"
            >
              <SettingsIcon />
            </IconButton>
          </AppTooltip>
        )}
      </div>
      <Typography variant="h1">TIMELINE APPLICATION</Typography>
      <Paper>
        <Outlet />
      </Paper>
    </div>
  );
};

export default AuthLayout;
